import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useTranslate } from "@tolgee/react";
import { useEffect } from "react";
import { toast } from "sonner";
import { PageLoader } from "#/components/ui/page-loader";
import { lookupReferralCode } from "#/lib/api/referrals";
import {
	clearPendingReferralCode,
	setPendingReferralCode,
} from "#/lib/api/token-storage";

export const Route = createFileRoute("/r/$code")({
	component: ReferralLanding,
});

function ReferralLanding() {
	const { code } = Route.useParams();
	const navigate = useNavigate();
	const { t } = useTranslate();

	useEffect(() => {
		let cancelled = false;

		lookupReferralCode(code)
			.then((canonical) => {
				if (cancelled) return;
				if (canonical) {
					setPendingReferralCode(canonical);
					// 진입 직후 랜딩으로 리다이렉트되며 뜨는 안내라 기본(4초)보다 길게 노출
					toast.success(t("referrals.landing.applied", { code: canonical }), {
						duration: 8000,
					});
				} else {
					// Stale or invalid link — ensure we don't apply an older pending
					// code from a previous visit.
					clearPendingReferralCode();
				}
			})
			.catch(() => {
				// Network error: don't clear any existing pending code; just redirect.
			})
			.finally(() => {
				if (cancelled) return;
				navigate({ to: "/", replace: true });
			});

		return () => {
			cancelled = true;
		};
	}, [code, navigate, t]);

	return <PageLoader />;
}
